import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { routeStateAtom } from "../../atoms";
import { getPageTitle } from "../../constants";
import { allRoutes } from "../routes.config";

const defaultTitle = import.meta.env.VITE_SITE_TITLE || "";
const envPrefix = import.meta.env.VITE_ENVIRONMENT !== "PRD" ? `**${import.meta.env.VITE_ENVIRONMENT}** - ` : "";

const createPageTitle = (page: string, isMidterm?: boolean) => {
  return `${envPrefix} ${getPageTitle(isMidterm)} - Motor - ${page}`;
};

export const TitleGuard: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { isMidterm } = useRecoilValue(routeStateAtom);

  useEffect(() => {
    if (document) {
      const route = allRoutes.find((item) => item.path === location.pathname);
      document.title = route?.name ? createPageTitle(route.name, isMidterm) : defaultTitle;
    }
  }, [location.pathname, isMidterm]);

  return <>{children}</>;
};
